export const userHasPermission = (user, permission) => {
  return (
    user &&
    user.permissions &&
    user.permissions.find((p) => p.rule === permission && p.allowed)
  );
};
